const TeamStyles = {
    teamWrapper : {
        padding: "20px 20px",
    }
};

export default TeamStyles;
